module.exports = __webpack_public_path__ + "img/download.2c3f4f4b.svg";